export default function SectionHeading({ eyebrow, title, subtitle, accent, align = "left", testid }) {
  return (
    <div
      data-testid={testid}
      className={`max-w-3xl mb-12 lg:mb-16 ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {eyebrow && (
        <p className="text-xs uppercase tracking-[0.3em] text-[#ffb700] mb-4 font-semibold">
          ◆ {eyebrow}
        </p>
      )}
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] text-balance">
        {title}{" "}
        {accent && <span className="phoenix-text">{accent}</span>}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base lg:text-lg text-white/65 leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
